import { Drawer, Stack } from "@mui/material";

export interface NavigationMenuDrawerMobileProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function NavigationMenuDrawerMobile(props: NavigationMenuDrawerMobileProps) {
  const { open, onClose, children } = props;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: (theme) => ({
          width: "100%",
          background: theme.palette.navbar?.gradient,
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "env(safe-area-inset-bottom)",
        }),
      }}
    >
      <Stack padding={3} gap={2} overflow="hidden">
        {children}
      </Stack>
    </Drawer>
  );
}
